import ptBR from './ptBR'

export default {
    values: {
        ...Object.keys(ptBR).reduce((prev, curr) => ({ ...prev, [curr]: curr }), {})
    }
}
